"use strict";
/**
 * 自定义发送大数据统计
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendPageID = void 0;
/** 存储页面上的pageid，因为自定义发送会把页面pageid改掉 */
var thispageid = 0;
if (window.emtj_pageId) {
    thispageid = window.emtj_pageId;
}
function defaultSend(pageid) {
    //满足手动发送大数据统计条件
    if (window.emtjLaunch && window.emtj_logSet.indexOf('0') == 0) {
        if (pageid) {
            window.emtjLaunch(pageid);
        }
        else if (thispageid) {
            window.emtjLaunch(thispageid);
        }
    }
}
//自定义大数据发送
var CustomPageId = [
    {
        pageid: 113200313001,
        href: ['/hsgt.html', '/gridlist.html#sh_hk_board', '/gridlist.html#sz_hk_board', '/gridlist.html#hk_sh_stocks', '/gridlist.html#hk_sz_stocks', '/gridlist.html#ah_comparison']
    },
    {
        pageid: 113200313002,
        href: ['/hsbk.html', '/gridlist.html#concept_board', '/gridlist.html#region_board', '/gridlist.html#industry_board', '/gridlist.html#industry_board_1', '/gridlist.html#industry_board_2', '/gridlist.html#industry_board_3']
    },
    {
        pageid: 113200313003,
        href: ['/hszs.html', '/gridlist.html#index_sh', '/gridlist.html#index_sz', '/gridlist.html#index_components', '/gridlist.html#index_zzzs']
    },
    {
        pageid: 113200313004,
        href: ['/gridlist.html#neeq_stocks', '/gridlist.html#neeq_selected', '/gridlist.html#neeq_innovate', '/gridlist.html#neeq_basic', '/gridlist.html#neeq_agreement', '/gridlist.html#neeq_marketmaking', '/gridlist.html#neeq_bidding']
    }
];
var sendPageID = function () {
    var thishref = location.href.toLocaleLowerCase();
    var fire = false;
    CustomPageId.forEach(function (v) {
        if (v.href.some(function (i) { return thishref.indexOf(i) > 0; })) {
            fire = true;
            defaultSend(v.pageid);
        }
    });
    if (!fire) {
        defaultSend();
    }
};
exports.sendPageID = sendPageID;
// sendPageID()
// window.addEventListener("hashchange",function(){
//   sendPageID()
// });
